exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".drop-shadow {\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.6);\n  width: 100%;\n  left: 0;\n  top: 0;\n  z-index: 1; }\n\n.modal.animated {\n  animation-duration: 200ms;\n  transform-origin: 50% 25%; }\n\n.modal .modal-header {\n  border-bottom: 0; }\n  .modal .modal-header button.close {\n    font-size: 30px; }\n\n.modal .modal-content {\n  background-color: #333;\n  color: #EEE; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/shared/modal/modal.scss
// module id = 361
// module chunks = 0